import React from "react";

const Audio = () => {
  return (
    <audio id="backgroundMusic" autoPlay>
      <source src="/audio/Clock.mp3" type="audio/mp3" />
    </audio>
  );
};

export default Audio;
